import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  HStack,
  Badge,
  useColorModeValue,
} from '@chakra-ui/react';

interface SportsPageShellProps {
  title: string;
  subtitle?: string;
  badge?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  maxW?: string;
  /** Padding horizontal del contenido (p. ej. en captura a ancho completo) */
  contentPx?: number | { base?: number; md?: number; lg?: number };
  /** Cabecera y padding del contenido más compactos */
  compact?: boolean;
}

export const SportsPageShell: React.FC<SportsPageShellProps> = ({
  title,
  subtitle,
  badge,
  actions,
  children,
  maxW = 'container.xl',
  contentPx,
  compact = false,
}) => {
  const headerBg = useColorModeValue('pitch.600', 'pitch.700');
  const badgeBg = useColorModeValue('gold.500', 'gold.400');
  const accentStripe = useColorModeValue('pitch.800', 'pitch.900');

  return (
    <Box>
      <Box bg={headerBg} color="white" py={compact ? { base: 4, md: 5 } : { base: 6, md: 8 }} px={4}>
        <Container maxW={maxW} px={contentPx}>
          <HStack justify="space-between" align="flex-start" flexWrap="wrap" gap={4}>
            <Box flex={1} minW={{ base: 0, sm: '200px' }}>
              {badge && (
                <Badge bg={badgeBg} color="slate.900" mb={2} fontSize="xs" px={2}>
                  {badge}
                </Badge>
              )}
              <Heading
                size={compact ? { base: 'md', md: 'lg' } : { base: 'lg', md: 'xl' }}
                letterSpacing="-0.02em"
              >
                {title}
              </Heading>
              {subtitle && (
                <Text mt={2} opacity={0.9} fontSize={{ base: 'sm', md: 'md' }}>
                  {subtitle}
                </Text>
              )}
            </Box>
            {actions && (
              <Box w={{ base: 'full', md: 'auto' }} flexShrink={0}>
                {actions}
              </Box>
            )}
          </HStack>
        </Container>
        <Box h="4px" bg={accentStripe} />
      </Box>
      <Container maxW={maxW} py={compact ? 4 : 6} px={contentPx}>
        {children}
      </Container>
    </Box>
  );
};
